import axios, { type AxiosError } from "axios"

interface ApiErrorResponse {
        message: string | { messages: string[] }
}

const api = axios.create({
        baseURL: `${import.meta.env.BASE_URL}api/`,
        withCredentials: true,
})

api.interceptors.response.use(
        (response) => response,
        (error: AxiosError<ApiErrorResponse>) => {
                const message = error.response?.data?.message
                error.message = (typeof message === "string" ? message : message?.messages.join(". "))
                        || "Не удалось связаться с сервером. Попробуйте ещё раз."
                return Promise.reject(error)
        },
)

export default api
